const checkObjectEmpty = (item) => {
	return Object.keys(item).length === 0;
};

export default checkObjectEmpty;
